import { Theme } from '@material-ui/core/styles/createTheme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import colors from './colors';
import { EdwardColors } from 'enums';

export default makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '825px',
    width: '98%',
    '& ._assetRow': {
      cursor: 'pointer',
      '& td:first-child': {
        width: '55px',
        paddingLeft: 0,
        paddingRight: 0,
        textAlign: 'center',

        '& button': {
          margin: 0,
          border: 'none',
        },
      },
    },
    '@media (max-width: 400px)': {
      width: '100%',
      '& .MuiTableCell-head': {
        lineHeight: '1.43',
      },
      '& .MuiTableCell-root': {
        fontSize: '10px !important',
        fontWeight: 'bold',
        paddingLeft: 0,
        paddingRight: 0,
        '&.categoryTitle': {
          fontSize: '14px !important',
        },
        '&._assetTitle': {
          fontSize: '12px !important',
        },
      },

      '& _.assetRow td.MuiTableCell-root:first-child': {
        paddingLeft: 0,
        paddingRight: 0,
        width: 'auto !important',
      },
      '& th.categoryHeader': { width: '30%', },
      '& th.categoryShare': { width: '25%', },
      '& th.categoryProfit': { width: '20%', },
      '& th.categoryCurrent': { width: '20%', },
      '& th:first-child': { width: '5%' }
    },
    margin: '0 auto',
    '& .category_IK1': { backgroundColor: colors.IK1 },
    '& .category_IK2': { backgroundColor: colors.IK2 },
    '& .category_IK3': { backgroundColor: colors.IK3 },
    '& .category_IK4': { backgroundColor: colors.IK4 },
    '& .category_IK5': { backgroundColor: colors.IK5 },
    '& th, & td': {
      textAlign: 'center',
    },
    '& .MuiTableRow-head th:nth-child(2)': {
      textAlign: 'left',
      paddingLeft: 0,
    },
    '& td.titleCell': {
      textAlign: 'left',
      paddingLeft: '0',
      '@media (max-width: 400px)': {
        paddingLeft: 0,
        paddingRight: theme.spacing(0.5),
      },
    },
    '&.planTable': {
      maxWidth: '1024px',
    },
    '&.comparisonTable': {
      marginBottom: theme.spacing(4),
      '& .currentShare': {
        color: EdwardColors.GRAY_LIGHTER
      },
      '& ._assetRow td:first-child': {
        width: '10px'
      },
      '& .currentShare, & .proposedShare': {
        fontWeight: 'bold'
      },
      '& .category td':{
        paddingTop: '2px',
        paddingBottom: '2px',
      },
      '& .category .categoryTitle, & .category .categoryShare': {
        fontSize: '18px'
      }
    },
    '&.historyTable': {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      '& td': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(0),
      },
      '& ._assetRow td': {
        height: '48px',
        minHeight: '48px',
        borderBottomStyle: 'dotted',
        borderBottomColor: '#ccc',
        '&:nth-child(4), &:nth-child(6)': {
          backgroundColor: '#fafafa',
        },
      }
    },
  },
  oddRow: {
    backgroundColor: theme.palette.grey['50'],
  },
  w50: {
    width: '50%',
  },
  expandAction: {
    marginLeft: '10px',
    minWidth: 0,
    padding: 0,
    '& svg': {
      width: '1.5em',
      height: '1.5em',
      transition: `transform .${theme.transitions.duration.short}s`,
    },
    '&.button_IK1 svg': { color: colors.IK1 },
    '&.button_IK2 svg': { color: colors.IK2 },
    '&.button_IK3 svg': { color: colors.IK3 },
    '&.button_IK4 svg': { color: colors.IK4 },
    '&.button_IK5 svg': { color: colors.IK5 },
    '&:hover': {
      paddingTop: '0',
      background: 'transparent',
    },
    '@media (max-width: 400px)': {
      margin: 0,
      width: '20px',
      height: '12px',
      '& svg': {
        width: '20px',
        height: '20px',
      },
    },
  },
  expandActionExpanded: {
    '& svg': {
      transform: 'rotate(180deg)',
    },
  },
}));
